import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

/* TipTap (READ ONLY) */
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { TextAlign } from "@tiptap/extension-text-align";
import CustomImageExtension from "./CustomImageExtension"; // adjust path if needed

const CustomerBlogList = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [selectedBlog, setSelectedBlog] = useState(null);

  

  /* -------------------------------------------------- */
  /* Extract preview text from TipTap JSON               */
  /* -------------------------------------------------- */
  const extractTextFromJSON = (jsonString) => {
    try {
      const json = JSON.parse(jsonString);
      let text = "";
      const walk = (node) => {
        if (node.type === "text") text += node.text + " ";
        if (node.content) node.content.forEach(walk);
      };
      walk(json);
      return text.trim();
    } catch {
      return "";
    }
  };

  /* -------------------------------------------------- */
  /* Fetch approved blogs                                */
  /* -------------------------------------------------- */
  const fetchBlogs = async () => {
    try {
      const res = await api.get("/api/blog/approved-only");
      setBlogs(res.data || []);
    } catch (err) {
      console.error("Error fetching blogs:", err);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  /* -------------------------------------------------- */
  /* Viewer component (READ ONLY TipTap)                 */
  /* -------------------------------------------------- */
  const BlogViewer = ({ content }) => {
    const editor = useEditor({
      editable: false,
      extensions: [
        StarterKit,
        TextAlign.configure({ types: ["heading", "paragraph"] }),
        CustomImageExtension,
      ],
      content: JSON.parse(content),
    });

    if (!editor) return null;
    return <EditorContent editor={editor} />;
  };

  /* -------------------------------------------------- */
  /* Render                                             */
  /* -------------------------------------------------- */
  return (
    <div className="container py-5">

      {/* Header */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-5">
        <div>
          <h2 className="fw-bold text-dark mb-2">📰 Latest Blogs</h2>
          <p className="text-muted">Explore blogs posted by our users</p>
        </div>

        <div className="d-flex gap-3 mt-3 mt-md-0">
          <button
            className="btn btn-primary fw-semibold px-4 py-2 rounded-pill shadow-sm"
            onClick={() => navigate("/customer/blogs/add")}
          >
            ➕ Add Blog
          </button>

          <button
            className="btn btn-outline-primary fw-semibold px-4 py-2 rounded-pill"
            onClick={() => navigate("/customer/customersroleblogs")}
          >
            👤 My Blogs
          </button>

          <button
            className="btn btn-outline-primary fw-semibold px-4 py-2 rounded-pill"
            onClick={() => window.history.back()}
          >
            ⬅ Back
          </button>
        </div>
      </div>

      {/* Blog Cards */}
      <div className="row g-4">
        {blogs.length > 0 ? (
          blogs.map((blog) => (
            <div key={blog.id} className="col-md-6 col-lg-4">
              <div className="card shadow-lg border-0 rounded-4 h-100 overflow-hidden">

                

                {/* Content */}
                <div className="card-body d-flex flex-column">
                  <h5 className="fw-bold text-dark">{blog.title}</h5>

                  {/* SAFE JSON PREVIEW */}
                  <p className="text-muted small mb-3">
                    {extractTextFromJSON(blog.textContent).slice(0, 120) || "No content"}…
                  </p>

                  <button
                    className="btn btn-primary btn-sm rounded-pill mt-auto align-self-end px-4 shadow-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#blogModal"
                    onClick={() => setSelectedBlog(blog)}
                  >
                    👁 View
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-muted mt-5 fs-5">
            No blogs available.
          </p>
        )}
      </div>

      {/* VIEW MODAL */}
      <div className="modal fade" id="blogModal" tabIndex="-1">
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content rounded-4 shadow-lg border-0">

            {selectedBlog && (
              <>
                <div className="modal-header bg-primary text-white">
                  <h4 className="modal-title fw-semibold">
                    {selectedBlog.title}
                  </h4>
                  <button
                    className="btn-close btn-close-white"
                    data-bs-dismiss="modal"
                  />
                </div>

                <div
                  className="modal-body p-4"
                  style={{ maxHeight: "80vh", overflowY: "auto" }}
                >
                  <BlogViewer content={selectedBlog.textContent} />
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary rounded-pill px-4"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerBlogList;
